<question-wrapper [title]="title">
  <div class="ic-question-text">
    <input
      [ngClass]="{ invalid: isEmpty }"
      class="ic-question-text__answer-input"
      placeholder="enter value"
      [(ngModel)]="value"
      type="text"
      (ngModelChange)="validateAnswer()"
    />
    @if (isEmpty) {
    <span class="ic-question-number_error">this is mandatory field</span>
    }
  </div>
</question-wrapper>
